'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Spinner_module = require('./Spinner.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Spinner = _ref => {
  let {
    width = 16
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    className: Spinner_module["default"].spinner,
    viewBox: "0 0 30 30",
    width: width
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.2 12.5c-.3 0-.5-.1-.8-.2l-3.7-2.2C3 9.6 2.8 8.7 3.2 8s1.3-.9 2.1-.5L9 9.7c.7.4.9 1.3.5 2.1-.2.5-.7.7-1.3.7zM26 21.9h-.1l-3.7-2.2c-.2-.1-.2-.3-.2-.4.1-.1.2-.2.3-.1l3.7 2.2c.1.1.2.2.1.3 0 .2 0 .2-.1.2zM8.8 26.9c-.2 0-.4 0-.5-.1-.5-.3-.6-.9-.3-1.4l2.2-3.7c.3-.5.9-.6 1.4-.3.5.3.6.9.3 1.4l-2.2 3.7c-.2.3-.5.4-.9.4zM11.3 9.6c-.5 0-1-.3-1.3-.8L7.9 5c-.4-.7-.1-1.6.6-2 .7-.4 1.6-.1 2 .6l2.1 3.8c.4.7.1 1.6-.6 2-.2.1-.4.2-.7.2zM21.2 26.7c-.2 0-.3-.1-.4-.3l-2.1-3.8c-.1-.2 0-.5.2-.7.2-.1.5 0 .7.2l2.1 3.8c.1.2 0 .5-.2.7-.1.1-.2.1-.3.1zM4.3 22.7c-.5 0-1-.3-1.3-.8-.4-.7-.1-1.6.6-2l3.8-2.1c.7-.4 1.6-.1 2 .6.4.7.1 1.6-.6 2L5 22.5c-.2.2-.5.2-.7.2zM15.2 8.6c-.8 0-1.5-.7-1.5-1.5V2.7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V7c0 .9-.6 1.6-1.5 1.6zM15.2 28.5c-.4 0-.8-.3-.8-.8v-4.3c0-.4.3-.8.8-.8s.8.4.8.8v4.3c0 .4-.3.8-.8.8zM7.1 16.7H2.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H7c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5z"
  }));
};

exports["default"] = Spinner;
